import { plainToInstance } from "class-transformer";
import { Guid } from 'guid-typescript'

import BaseButtonBuilder, { BaseButtonViewData } from '../index'
import { BaseButton, ButtonTypes } from '../types'
import buttonView from './LinkButtonView.vue'
import setupView from './LinkSetupView.vue'

export default class LinkButtonBuilder extends BaseButtonBuilder {
  type = ButtonTypes.Link

  titleKey = ButtonTypes.Link

  setupView = setupView
  buttonView = buttonView

  icon = '🔗'

  data = {
    text: '',
    link: '',
  }

  getData(button: LinkButton): LinkButtonData {
    return button ? new LinkButtonData(button.text, button.link) : new LinkButtonData(this.$i18n.t('initial_text_message_editor_buttons').toString(), '')
  }

  // structBuilder = LinkButton

  create(): LinkButton {
    return plainToInstance(LinkButton, {
      ...this.data,
      type: ButtonTypes.Link,
      guid: Guid.create().toString()
    })
  }
}

class LinkButtonData implements BaseButtonViewData {
  text: string
  link = ''

  constructor(text: string, link?: string) {
    this.text = text

    if (link) {
      this.link = link
    }
  }
}

export class LinkButton implements BaseButton {
  text!: string
  type!: ButtonTypes.Link
  guid!: string
  link!: string
}
